var _defs, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgObdRemoteUnlock(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 283.46 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: currentColor;\n      }\n\n      .cls-2 {\n        fill: currentColor;\n      }\n\n      .cls-3 {\n        fill: currentColor;\n      }\n\n      .cls-4 {\n        fill: currentColor;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M130.65,116.5c-2.49,0-4.5-2.01-4.5-4.5v-15.23c0-2.49,2.01-4.5,4.5-4.5s4.5,2.01,4.5,4.5v15.23c0,2.49-2.01,4.5-4.5,4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M149.82,116.5c-2.49,0-4.5-2.01-4.5-4.5v-15.23c0-2.49,2.01-4.5,4.5-4.5s4.5,2.01,4.5,4.5v15.23c0,2.49-2.01,4.5-4.5,4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M149.82,229.71c-2.49,0-4.5-2.01-4.5-4.5v-15.23c0-2.49,2.01-4.5,4.5-4.5s4.5,2.01,4.5,4.5v15.23c0,2.49-2.01,4.5-4.5,4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M168.99,229.71c-2.49,0-4.5-2.01-4.5-4.5v-15.23c0-2.49,2.01-4.5,4.5-4.5s4.5,2.01,4.5,4.5v15.23c0,2.49-2.01,4.5-4.5,4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M188.15,229.71c-2.49,0-4.5-2.01-4.5-4.5v-15.23c0-2.49,2.01-4.5,4.5-4.5s4.5,2.01,4.5,4.5v15.23c0,2.49-2.01,4.5-4.5,4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M223.63,194.24h-15.23c-2.49,0-4.5-2.01-4.5-4.5s2.01-4.5,4.5-4.5h15.23c2.49,0,4.5,2.01,4.5,4.5s-2.01,4.5-4.5,4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M223.63,175.07h-15.23c-2.49,0-4.5-2.01-4.5-4.5s2.01-4.5,4.5-4.5h15.23c2.49,0,4.5,2.01,4.5,4.5s-2.01,4.5-4.5,4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M110.41,136.74h-15.23c-2.49,0-4.5-2.01-4.5-4.5s2.01-4.5,4.5-4.5h15.23c2.49,0,4.5,2.01,4.5,4.5s-2.01,4.5-4.5,4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M110.41,155.91h-15.23c-2.49,0-4.5-2.01-4.5-4.5s2.01-4.5,4.5-4.5h15.23c2.49,0,4.5,2.01,4.5,4.5s-2.01,4.5-4.5,4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M194.78,214.48h-64.13c-2.49,0-4.5-2.01-4.5-4.5s2.01-4.5,4.5-4.5h64.13c5.03,0,9.11-4.09,9.11-9.11v-70.76c0-5.03-4.09-9.11-9.11-9.11h-70.76c-5.03,0-9.11,4.09-9.11,9.11v35.38c0,2.49-2.01,4.5-4.5,4.5s-4.5-2.01-4.5-4.5v-35.38c0-9.99,8.13-18.11,18.11-18.11h70.76c9.99,0,18.11,8.13,18.11,18.11v70.76c0,9.99-8.13,18.11-18.11,18.11Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M105.76,217.3h-45.34c-5.72,0-10.83-3.63-12.71-9.03l-6.36-18.21c-1.44-4.11-.79-8.69,1.73-12.24,2.52-3.55,6.63-5.67,10.98-5.67h58.05c4.35,0,8.46,2.12,10.98,5.67,2.52,3.55,3.17,8.13,1.73,12.24l-6.36,18.21c-1.89,5.4-7,9.03-12.71,9.03ZM54.07,179.15c-2.12,0-4.05.99-5.27,2.72-1.23,1.73-1.53,3.87-.83,5.88l6.36,18.21c.91,2.59,3.36,4.34,6.11,4.34h45.34c2.75,0,5.2-1.74,6.11-4.34l6.36-18.21c.7-2,.4-4.15-.83-5.88-1.23-1.73-3.15-2.72-5.27-2.72h-58.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M102.49,198.23h-38.81c-1.93,0-3.5-1.57-3.5-3.5s1.57-3.5,3.5-3.5h38.81c1.93,0,3.5,1.57,3.5,3.5s-1.57,3.5-3.5,3.5Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M224.04,131.59c-2.49,0-4.5-2.01-4.5-4.5v-48.41c0-8.78-8-15.92-17.82-15.92s-17.82,7.14-17.82,15.92c0,2.49-2.01,4.5-4.5,4.5s-4.5-2.01-4.5-4.5c0-13.74,12.03-24.92,26.82-24.92s26.82,11.18,26.82,24.92v48.41c0,2.49-2.01,4.5-4.5,4.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 163.99,
    y: 95.15,
    width: 75.38,
    height: 62.6,
    rx: 12.1,
    ry: 12.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObdRemoteUnlock);
export default __webpack_public_path__ + "static/media/obd-remote-unlock.3b2b947449f53461f8b51396f7569c4d.svg";
export { ForwardRef as ReactComponent };